import { Fragment } from "react";
import { useTranslation } from "next-i18next";
import Product from "../../ProductCard/Product";
import { OFFSET, CARDS_PER_PAGE } from "./lib/constants";
import { RenderContentSection } from "./RenderContentSection";
import styles from "./products.module.css";

export function ProductsView({
  collection,
  contentSections,
  showContentFirst,
  state,
  paginationRef,
  loadMoreProducts,
  filteredValues,
  clearFilters,
  productList,
}) {
  const { t } = useTranslation("collectionpage");
  const LOADING = t("loading-button");
  const SHOW_MORE = t("show-more-button");

  const contentSectionsExist = contentSections && contentSections.length > 0;
  return (
    <main className={styles.wrapper}>
      <section className={styles.grid}>
        {productList &&
          productList.slice(0, state.page * OFFSET).map((product, index) => {
            return (
              <Fragment key={product.id}>
                {contentSectionsExist && index % CARDS_PER_PAGE === 0 && (
                  <RenderContentSection
                    contentSections={contentSections}
                    showContentFirst={showContentFirst}
                    prodIndex={index}
                  />
                )}

                <Product product={product} collection={collection} listPosition={index} />
              </Fragment>
            );
          })}
        {productList &&
          productList.length === 0 &&
          Object.keys(filteredValues).some((key) => filteredValues[key].length !== 0) && (
            <div className={styles.message}>
              <p>No products matched those filters. </p>
              <p onClick={clearFilters}>Start fresh?</p>
            </div>
          )}
        {productList && state.offset < productList.length && <div ref={paginationRef} />}
      </section>
      {productList && state.page * OFFSET < productList.length && (
        <div className={styles.moreContainer}>
          <button
            className={styles.moreButton}
            onClick={() => loadMoreProducts()}
            disabled={state.isFetching}
          >
            {state.isFetching ? LOADING : SHOW_MORE}
          </button>
        </div>
      )}
    </main>
  );
}